import { Button } from '@/components/ui/button'
import { Spinner } from '@/components/ui/spinner'
import { AlertTriangle, ArrowLeft, UserX } from 'lucide-react'
import { cn } from '@/lib/utils'

interface LoadingStateProps {
  message?: string
  className?: string
}

export function LoadingState({ message = 'Loading your role assignment...', className }: LoadingStateProps) {
  return (
    <div className={cn('flex flex-col items-center justify-center py-16 gap-4 rounded-2xl border border-[#CED4DE] bg-white px-8 shadow-sm', className)}>
      <Spinner className="size-8 text-[#367A25]" />
      <p className="text-slate-600">{message}</p>
    </div>
  )
}

interface ErrorStateProps {
  message: string
  onBack?: () => void
  className?: string
}

export function ErrorState({ message, onBack, className }: ErrorStateProps) {
  return (
    <div className={cn('flex flex-col items-center justify-center py-16 gap-4 text-center rounded-2xl border border-[#CED4DE] bg-white px-8 shadow-sm', className)}>
      <div className="size-12 rounded-full bg-[#DD6832]/15 flex items-center justify-center">
        <AlertTriangle className="size-6 text-[#DD6832]" />
      </div>
      <div className="space-y-1">
        <h3 className="font-semibold text-[#12356B]">Something went wrong</h3>
        <p className="text-sm text-slate-600 max-w-md">{message}</p>
      </div>
      {onBack && (
        <Button variant="outline" onClick={onBack} className="mt-2 bg-transparent border-[#12356B] text-[#12356B] hover:bg-[#E2E5EC] hover:text-[#12356B]">
          <ArrowLeft className="size-4 mr-2" />
          Back to Join Page
        </Button>
      )}
    </div>
  )
}

interface PlayerNotFoundStateProps {
  onBack?: () => void
  className?: string
}

export function PlayerNotFoundState({ onBack, className }: PlayerNotFoundStateProps) {
  return (
    <div className={cn('flex flex-col items-center justify-center py-16 gap-4 text-center rounded-2xl border border-[#CED4DE] bg-white px-8 shadow-sm', className)}>
      <div className="size-12 rounded-full bg-[#E2E5EC] flex items-center justify-center">
        <UserX className="size-6 text-[#12356B]" />
      </div>
      <div className="space-y-1">
        <h3 className="font-semibold text-[#12356B]">Player Not Found</h3>
        <p className="text-sm text-slate-600">
          Player information could not be found for this session.
        </p>
      </div>
      {onBack && (
        <Button variant="outline" onClick={onBack} className="mt-2 bg-transparent border-[#12356B] text-[#12356B] hover:bg-[#E2E5EC] hover:text-[#12356B]">
          <ArrowLeft className="size-4 mr-2" />
          Back to Join Page
        </Button>
      )}
    </div>
  )
}
